module.exports = __webpack_public_path__ + "static/media/claimlink.11ef03bb.png";